import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import PaymentCG from '../SaleBlock/PaymentCG/PaymentCG';
import {cgTypeEnum} from '../../../utilities/enums/cgTypeEnum';
import {
  blackListValidation,
  jetUpdateOpportunityCreditCard,
  closingMagicLink,
  setCurrentProgramStep,
  setNextPhaseBtnPressed,
  setMlOpportunityId,
} from './OccasionalCreditCardInputSlice';
import {ProgramSteps, ProcessRelevantRoles} from './OccasionalCreditCardInputEnumsAndVariables';
import {isTokenIsValidForProcess} from '../../../utilities/StringHelpers/StringHelpers';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';

const OccasionalCreditCardInputMain = ({
  userToken,
  opportunityId,
  blackListValReqCompletedSuccessfully,
  blackListValReqCompletedWithError,
  jetUpdateReqCompletedSuccessfully,
  jetUpdateCompletedWithError,
  pymBlackListInd,
  capacityOverflowInd,
  delinquentCustomersInd,
  emvStep2Completed,
  paymentCg,
  blackListValidation,
  jetUpdateOpportunityCreditCard,
  closingMagicLink,
  customerFirstName,
  customerLastName,
  iContent,
  setCurrentProgramStep,
  setNextPhaseBtnPressed,
  currentStep,
  tokenRolesList,
  isNextPhaseBtnPressed,
  isLoading,
  showAppLoader,
  hideAppLoader,
  setMlOpportunityId,
}) => {
  const title = iContent?.title?.value;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (isLoading) {
      showAppLoader();
    } else {
      hideAppLoader();
    }
  }, [isLoading]);

  useEffect(() => {
    if (blackListValReqCompletedWithError) {
      setCurrentProgramStep(ProgramSteps.BLACK_LIST_VALIDATION_GENERAL_ERROR);
    }
  }, [blackListValReqCompletedWithError]);

  useEffect(()=>{
    if(jetUpdateCompletedWithError){
      setCurrentProgramStep(ProgramSteps.JET_UPDATE_GENERAL_ERROR);
    }
  },[jetUpdateCompletedWithError]);

  useEffect(() => {
    if (!isTokenIsValidForProcess(userToken, tokenRolesList, ProcessRelevantRoles)) {
      setCurrentProgramStep(ProgramSteps.ERROR_WITH_TOKEN);
    } else if (!opportunityId) {
      setCurrentProgramStep(ProgramSteps.OPPORTUNITY_ID_NOT_FOUND);
    } else {
      setMlOpportunityId(opportunityId);
      if (currentStep !== ProgramSteps.MAIN) {
        setCurrentProgramStep(ProgramSteps.MAIN);
      }
    }
  }, [userToken, opportunityId]);

  useEffect(() => {
    const activateBlackListValidation = async (data) => {
      await blackListValidation(data);
    };
    if (isNextPhaseBtnPressed) {
      setNextPhaseBtnPressed(false);
      activateBlackListValidation({
        creditCardType: paymentCg.CGData?.ccType,
        creditCardNumber: paymentCg.CGData?.ccToken,
        idNumber: paymentCg.CGData?.id,
      });
    }
  }, [isNextPhaseBtnPressed]);

  useEffect(() => {
    const activateSendDataToJetFunc = async () => {
      const dataToSend = {
        creditCardNumber: paymentCg.CGData?.ccToken,
        expirationDate: paymentCg.CGData?.cardExpiration,
        idNumber: paymentCg.CGData?.id,
        creditCardType: paymentCg.CGData?.ccType,
        terminalNumber: paymentCg.CGData?.terminalNumber,
        authNumber: paymentCg.CGData?.authNumber,
        cardBrand: paymentCg.CGData?.cardBrand,
        creditCompany: paymentCg.CGData?.creditCompany,
        pymBlackList: pymBlackListInd,
        capacityOverflow: capacityOverflowInd,
        delinquentCustomers: delinquentCustomersInd,
      };
      await jetUpdateOpportunityCreditCard(dataToSend);
    };
    if (blackListValReqCompletedSuccessfully) {
      activateSendDataToJetFunc();
    }
  }, [blackListValReqCompletedSuccessfully]);

  useEffect(() => {
    if (jetUpdateReqCompletedSuccessfully) {
      if (pymBlackListInd === 'N' && delinquentCustomersInd === 'N') {
        closeMlConnection();
      }
      setCurrentProgramStep(ProgramSteps.SUCCESS_PAGE);
    }
  }, [jetUpdateReqCompletedSuccessfully]);

  async function closeMlConnection() {
    const dataToSend = {
      clientName: 'JET',
      scopeName: 'CreditCardInfo',
    };
    await closingMagicLink(dataToSend);
  }

  return (
    <div className='occasional-credit-card-input-main'>
      <div className='header'>
        {customerFirstName && customerLastName && (
          <div className='customer-welcoming'>{`שלום ${customerLastName} ${customerFirstName}`}</div>
        )}
        {title && <div className='title'>{title}</div>}
      </div>
      <PaymentCG
        isHideTermsCheckbox
        padding='0'
        paymentRequestedQuantity={9}
        noLoader
        type={cgTypeEnum.CHECKCARD}
        isShowIdNumber={true}
        isOccasionalCreditCard={true}
        isNoIDNumberRequired={true}
        source="OccasionalCreditCardInputBlock"
      />
      {emvStep2Completed && (
        <div className='btn-wrapper'>
          <BtnSubmit text='אישור וסיום' onclick={() => setNextPhaseBtnPressed(true)} />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  paymentCg: state.PaymentCG,
  emvStep2Completed: state.PaymentCG.emvStep2CompletedSuccessfully,
  userToken: state.authentication?.loginData?.token,
  opportunityId: state.authentication?.loginData?.magicLinkParameters?.opportunityId,
  tokenRolesList: state.authentication?.loginData?.userDetails?.RoleList,
  pymBlackListInd: state.OccasionalCreditCardInput?.blackListValidationInfo?.data?.pym_Black_List_Ind,
  capacityOverflowInd: state.OccasionalCreditCardInput?.blackListValidationInfo?.data?.capacity_Overflow_Ind,
  delinquentCustomersInd: state.OccasionalCreditCardInput?.blackListValidationInfo?.data?.delinquent_Customers_Ind,
  blackListValReqCompletedSuccessfully: state.OccasionalCreditCardInput?.blackListValidationInfo?.reqCompletedSuccessfully,
  jetUpdateReqCompletedSuccessfully: state.OccasionalCreditCardInput?.creditCardJetInfo?.reqCompletedSuccessfully,
  blackListValReqCompletedWithError: state.OccasionalCreditCardInput?.blackListValidationInfo?.reqCompletedWithError,
  jetUpdateCompletedWithError: state.OccasionalCreditCardInput?.creditCardJetInfo?.reqCompletedWithError,
  currentStep: state.OccasionalCreditCardInput?.currentProgramStep,
  isNextPhaseBtnPressed: state.OccasionalCreditCardInput?.isNextPhaseBtnPressed,
  isLoading: state.OccasionalCreditCardInput?.isLoading,
  customerFirstName: state.authentication?.loginData?.userDetails?.firstName,
  customerLastName: state.authentication?.loginData?.userDetails?.lastName,
});

const mapDispatchToProps = {
  blackListValidation,
  jetUpdateOpportunityCreditCard,
  closingMagicLink,
  setCurrentProgramStep,
  setNextPhaseBtnPressed,
  showAppLoader,
  hideAppLoader,
  setMlOpportunityId,
};

export default connect(mapStateToProps, mapDispatchToProps)(OccasionalCreditCardInputMain);
